// An invitation email (admin → Prospects) opens the library with ?vbp=<token>.
// The browser keeps it for 90 days, so a licence or footage request sent
// later is shown on that company in the admin, even from a personal address.

import axiosInstance from "../../api/axios.instance";

const KEY = "vb_prospect_ref";
const DAYS = 90;

export const captureProspectRef = () => {
  try {
    const url = new URL(window.location.href);
    const token = url.searchParams.get("vbp");
    if (!token) return;
    if (/^[a-f0-9]{64}$/i.test(token)) {
      watchForPerson(token);
      localStorage.setItem(KEY, JSON.stringify({ token, at: Date.now() }));
    }
    // the address stays clean (sharing, analytics)
    url.searchParams.delete("vbp");
    window.history.replaceState(window.history.state, "", `${url.pathname}${url.search}${url.hash}`);
  } catch (e) {
    // private mode: nothing to keep
  }
};

// Mail scanners open every link in an email by themselves and only load the
// page; a person scrolls, taps or types. The first such sign tells the admin
// that a reader came (admin → Prospects: "Visited").
const PERSON_EVENTS = ["pointerdown", "keydown", "touchstart", "wheel"];
const watchForPerson = (token) => {
  const fire = () => {
    PERSON_EVENTS.forEach((e) => window.removeEventListener(e, fire, true));
    axiosInstance.post(`/prospects/h/${token}`).catch(() => {});
  };
  // a moment after load: nothing a page does by itself on opening counts
  setTimeout(() => PERSON_EVENTS.forEach((e) => window.addEventListener(e, fire, { capture: true, passive: true })), 1500);
};

export const prospectRef = () => {
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) || "null");
    return saved && Date.now() - saved.at < DAYS * 864e5 ? saved.token : undefined;
  } catch (e) {
    return undefined;
  }
};
